<template>
  <div>
    <input v-model="amount" type="number" class="px-5 w-full h-12 text-black bg-white border-b-2 rounded-xl" />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

const emit = defineEmits(['valueUpdate'])

const amount = ref<number>(0)

watch(amount, (newValue) => {
  // do a check for valid or isNan of number type
  emit('valueUpdate', newValue)
})
</script>

<style lang="scss" scoped></style>
